import {Col, Container, ProgressBar, Row} from "react-bootstrap";
import "./SectionProgress.css"
import {sectionNameForPage, VIEW_SECTIONS} from "../scripts/constants";

function SectionProgress(props) {
  
  const sections = VIEW_SECTIONS;
  const sectionName = props.currentPage ? sectionNameForPage(props.currentPage) : '';
  const sectionIndex = sections.map(section=>section.name).indexOf(sectionName);
  const progress = (sections.length>0 && sectionIndex>=0) ? Math.round(Math.min(100, 100 * (sectionIndex+1) / sections.length)) : -1;
  
  return (
      <>
        {
          progress >= 0 && (
              <div className="section-progress pl-4 pr-4">
                <Row className={'text-center'}>
                  <Col>
                    <div>
                      {sections[sectionIndex].label}
                    </div>
                  </Col>
                </Row>
                <Row className={'text-center pb-3'}>
                  <Col>
                    <ProgressBar now={progress} label={`${progress}%`} />
                  </Col>
                </Row>
              </div>
          )
        }
      </>
  );

}

export default SectionProgress;